import { render } from "./MainWorkSchedules.vue?vue&type=template&id=08f0811a&scoped=true"
import script from "./MainWorkSchedules.vue?vue&type=script&lang=js"
export * from "./MainWorkSchedules.vue?vue&type=script&lang=js"

import "./MainWorkSchedules.vue?vue&type=style&index=0&id=08f0811a&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f0811a"]])

export default __exports__